import type { TableColumns } from '@ohpen/enso-ui';
import { ExportTemplateResponse, FieldType } from '@pmp/api';

export const exportTemplatesColumns: TableColumns<ExportTemplateResponse> = [
  {
    title: 'pmp.products.labels.exportTemplateName',
    dataIndex: 'name',
    key: 'name',
    width: 320,
  },
  {
    title: 'global.labels.entityType',
    dataIndex: 'entityType',
    key: 'entityType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_ENTITY_TYPE,
    },
  },
  {
    title: 'global.labels.description',
    dataIndex: 'description',
    key: 'description',
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
